module.exports = __webpack_public_path__ + "static/img/honor-4.44fb5c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-4.png
// module id = Lcsy
// module chunks = 0